require('simplelightbox');
require('slick-carousel');
require('./theme.jquery');
require('./jquery.matchHeight');

// Sass
require('./../sass/index.sass');